import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { LottiePlayer, LottiePlayerContianerProps } from "./LottiePlayer";
import usePresidentFound from "../../hooks/usePresidentFound";

const StyledPlayer = styled(LottiePlayer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

export const Confetti: React.FC<LottiePlayerContianerProps> = (props) => {
  const [presidentFound, reset] = usePresidentFound();

  const [animationData, setAnimationData] = useState<any | null>(null);
  useEffect(() => {
    import("./confetti-animation.json?raw").then((module) => {
      setAnimationData(JSON.parse(module.default));
    });
  }, []);

  if (!animationData) {
    return null;
  }

  return (
    <StyledPlayer
      {...props}
      play={presidentFound}
      onEnd={reset}
      animationData={animationData}
      rendererSettings={{}}
    />
  );
};
